function triggerEdapEvent(trackingContext, text, type) {
    let field = {};
    switch (type) {
        case 'modal':
            field = {
                action_location: 'in-bottom',
                placement_type: 'modal'
            };
            break;
        case 'embedded':
            field = {
                action_location: 'inline',
                placement_type: 'embedded'
            };
            break;
        default:
            field = {
                action_location: 'above-header',
                placement_type: 'banner'
            };
    }
    trackingContext.trigger(`native_adoption_placement.${text}`, field);
}
export {triggerEdapEvent};